export const Sound =
    {
        NOTIFICATION: 'NOTIFICATION',
        INTROSOUND: 'INTROSOUND',
        ACTIVITYSTARTED: 'ACTIVITYSTARTED',
        APPLAUSE: 'APPLAUSE',
        LEVELUP: 'LEVELUP',
        BABAYETU: 'BABAYETU',
        ITEMUNLOCKED: 'ITEMUNLOCKED'
    }